import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** Route guard (beforeLoad): notifications ship behind the `collaboration` feature flag. */
export async function requireCollaborationFeature(queryClient: QueryClient): Promise<void> {
  const { flags } = await queryClient.query(featuresQuery);
  if (!flags.collaboration) throw notFound();
}
